import api from '@/api'

export default {
  me() {
    return api.get('/me')
  },

  all() {
    return api.get('/users')
  },
}
